module.exports = __webpack_public_path__ + "media/images/icons/material/ok-puerto-rico-a962b9e37d6583857ac5b8d212e68d22.svg";